export default "__VITE_PUBLIC_ASSET__76c62d03__"